import type { SprintEntity } from '@data';

/** Someone is on the product when they put more than this many hours into its last two closed sprints. */
export const ACTIVE_HOURS = 10;
export const ACTIVE_SPRINTS = 2;

type Entry = { minutes: number; involvement?: { membership?: { id?: string } } };

/** Who put more than ACTIVE_HOURS into the last ACTIVE_SPRINTS of these closed sprints, oldest first. */
export const activeMemberIds = (sprints: SprintEntity[], reportsBySprint: Record<string, Entry[]>): Set<string> => {
  const recent = sprints.slice(-ACTIVE_SPRINTS).flatMap(sprint => reportsBySprint[sprint.id] ?? []);
  const minutesByPerson = recent.reduce<Record<string, number>>((acc, entry) => {
    const id = entry.involvement?.membership?.id;
    if (id) acc[id] = (acc[id] ?? 0) + (entry.minutes ?? 0);
    return acc;
  }, {});
  return new Set(Object.keys(minutesByPerson).filter(id => minutesByPerson[id] > ACTIVE_HOURS * 60));
};
